import { render, staticRenderFns } from "./CompanyGroupList.vue?vue&type=template&id=47d769ce&scoped=true"
import script from "./CompanyGroupList.vue?vue&type=script&lang=js"
export * from "./CompanyGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d769ce",
  null
  
)

export default component.exports